/* Cartwala immediate Add to Cart loading feedback; no extra cart requests. */
(function(){
  "use strict";
  if(window.__cwInstantCartLoading)return;
  window.__cwInstantCartLoading=true;
  var busy=false,started=0,networkStarted=false,progressTimer,timeoutTimer;
  var addSelector='form[data-main-add-to-cart] [data-add-to-cart], .cw-single-action-button[data-action="add"]';
  var formSelector='form[data-main-add-to-cart], main form[action*="/cart/add"]';
  var form=document.querySelector(formSelector);
  var label="Adding to Cart…";

  function isCartOpen(){
    return !!document.querySelector('#cart-drawer.is-open,#CartDrawer.is-open,.cart-drawer.is-open,[data-cart-drawer].is-open');
  }
  function isVisible(button){
    if(!button||button.disabled||button.hidden||button.closest('[hidden]'))return false;
    var style=getComputedStyle(button);
    return style.display!=="none"&&style.visibility!=="hidden";
  }
  function announce(text){
    var node=document.getElementById("cw-cart-loading-status");
    if(!node){
      node=document.createElement("div");node.id="cw-cart-loading-status";
      node.className="cw-cart-loading-accessible";node.setAttribute("role","status");
      node.setAttribute("aria-live","polite");document.body.appendChild(node);
    }
    node.textContent=text;
  }
  function decorate(){
    document.querySelectorAll(addSelector).forEach(function(button){
      if(button.getAttribute("data-cw-loading-label")!==label)button.setAttribute("data-cw-loading-label",label);
      if(button.getAttribute("aria-busy")!=="true")button.setAttribute("aria-busy","true");
    });
  }
  function stop(){
    if(!busy)return;
    busy=false;clearTimeout(progressTimer);clearTimeout(timeoutTimer);
    document.body.classList.remove("cw-atc-loading");
    if(form)form.removeAttribute("aria-busy");
    document.querySelectorAll(addSelector).forEach(function(button){
      button.removeAttribute("aria-busy");button.removeAttribute("data-cw-loading-label");
    });
    announce("");
  }
  function begin(){
    if(busy||isCartOpen())return;
    form=document.querySelector(formSelector);
    if(!form)return;
    busy=true;networkStarted=false;started=Date.now();
    label="Adding to Cart…";
    document.body.classList.add("cw-atc-loading");
    form.setAttribute("aria-busy","true");
    decorate();
    announce("Adding your item to the cart. Please wait.");
    progressTimer=setTimeout(function(){
      if(!busy)return;
      label=networkStarted?"Adding to Cart…":"Preparing your photos…";
      decorate();announce("Your personalised gift is being prepared. Please wait.");
    },8000);
    timeoutTimer=setTimeout(function(){
      if(!busy)return;
      stop();
      announce("This is taking longer than expected. Check your cart before trying again.");
    },90000);
  }

  document.addEventListener("cartwala:save-progress",function(event){
    var detail=event.detail||{},labels=window.CartwalaSaveLabels||{};
    if(detail.form&&detail.form!==document.querySelector(formSelector))return;
    if(detail.stage==="idle"){stop();return;}
    begin();
    clearTimeout(progressTimer);
    label=detail.stage==="adding"?(labels.adding||"Adding to Cart…"):
      detail.stage==="opening"?(labels.opening||"Opening your cart…"):
      detail.message||(labels.saving_cart||"Saving your photos…");
    decorate();announce(label);
  });

  // Capture clicks before asynchronous image uploads begin.
  document.addEventListener("click",function(event){
    var button=event.target&&event.target.closest&&
      event.target.closest('[data-add-to-cart],[data-cw-single-action]');
    if(!button||button.closest('#cart-drawer,[role="dialog"],dialog'))return;
    if(button.hasAttribute("data-cw-single-action")&&button.dataset.action!=="add")return;
    if(!isVisible(button))return;
    begin();
  },true);
  document.addEventListener("submit",function(event){
    if(!event.target||!event.target.matches(formSelector))return;
    if(isVisible(event.target.querySelector("[data-add-to-cart]")))begin();
  },true);

  // Observe existing Shopify AJAX without altering its Promise or response.
  var previousFetch=window.fetch;
  if(typeof previousFetch==="function"){
    window.fetch=function(input,options){
      var uri=typeof input==="string"?input:input&&input.url||"";
      var adding=/\/cart\/add(?:\.js)?(?:\?|$)/.test(uri);
      if(adding){if(!busy)begin();networkStarted=true;}
      var request;
      try{request=previousFetch.apply(this,arguments);}
      catch(error){if(adding)stop();throw error;}
      if(adding)Promise.resolve(request).then(function(response){
        if(!response.ok)stop();
      },stop);
      return request;
    };
  }
  ["cartwala:item-added","cartwala:cart-complete"].forEach(function(event){
    document.addEventListener(event,stop);
  });
  var drawer=document.querySelector("#cart-drawer");
  if(drawer)new MutationObserver(function(){
    if(isCartOpen())stop();
  }).observe(drawer,{attributes:true,attributeFilter:["class","open","aria-hidden"]});
  document.addEventListener("cart:updated",function(){if(isCartOpen())stop();});
  window.addEventListener("pagehide",stop);

  // When photo preparation fails before any request, the customizer re-enables
  // the button. Release loading without allowing premature success resets.
  if(form){
    var mainButton=form.querySelector("[data-add-to-cart]");
    if(mainButton){
      var wasDisabled=false;
      new MutationObserver(function(){
        if(!busy){wasDisabled=false;return;}
        if(mainButton.disabled){wasDisabled=true;return;}
        if(wasDisabled&&!networkStarted&&Date.now()-started>400){
          wasDisabled=false;
          setTimeout(function(){
            if(busy&&!networkStarted&&!mainButton.disabled&&!isCartOpen())stop();
          },450);
        }
      }).observe(mainButton,{attributes:true,attributeFilter:["disabled"]});
    }
  }
})();